import useAppContext from "@src/modules/App/hooks/useAppContext";

const useNotificationsContext = () => useAppContext().notifications;

export default useNotificationsContext;
